import { Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { routesGuest } from '../../../consts'
import { COLORS } from '../../../styles/variables'

const consentTextSx = {
  color: COLORS.SMOKEY_GREY,
  fontSize: 12,
  lineHeight: '18px',
  textAlign: 'center',
  marginTop: 1.5,
}

export function AuthLegalConsent() {
  return (
    <Typography sx={consentTextSx}>
      Продолжая, вы принимаете{' '}
      <Link
        component={RouterLink}
        to={`/${routesGuest.RULES.path}`}
        underline="hover"
        sx={{ color: COLORS.NICE_BLUE, fontSize: 'inherit' }}
      >
        Правила сообщества
      </Link>{' '}
      и{' '}
      <Link
        component={RouterLink}
        to={`/${routesGuest.PRIVACY.path}`}
        underline="hover"
        sx={{ color: COLORS.NICE_BLUE, fontSize: 'inherit' }}
      >
        политику конфиденциальности
      </Link>
      .
    </Typography>
  )
}
